/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-logout': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(9 9)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M6.045 6.822c0 .518.428.937.955.937.527 0 .955-.42.955-.937V.937A.946.946 0 007 0a.946.946 0 00-.955.938v5.884z"/><path pid="1" d="M.127 7.208c-.423 2.907 1.094 5.753 3.767 7.068 2.674 1.314 5.903.802 8.019-1.273a6.692 6.692 0 001.96-5.799 6.894 6.894 0 00-3.649-5.079.97.97 0 00-.979-.006.934.934 0 00-.47.844.937.937 0 00.535.806 5.034 5.034 0 012.673 3.703c.31 2.109-.788 4.177-2.728 5.131a5.104 5.104 0 01-5.819-.925 4.855 4.855 0 01-1.423-4.204 5.03 5.03 0 012.67-3.702.936.936 0 00.507-.802.934.934 0 00-.462-.828.97.97 0 00-.961-.014 6.89 6.89 0 00-3.64 5.08z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-logout.js